export enum EREVERSESOLICITATIONTypes {
    UPDATE_DATA = '[kyc_broker_17] update data',
    UPDATE_DATA_SUCCESS = '[kyc_broker_17] update data success',
    UPDATE_DATA_FAILED = '[kyc_broker_17] update data failed',
}
